<template ref="indexLogoList">
  <section class="index-logo-list-root logoBox g-box">
    <div class="box">
      <div class="box-li" ref="logow">
        <ul class="logo-ul">
          <li class="logo-li" v-for="(item,index) in logoArr" :key="index">
            <img class="img" :src="item.img" alt="" @click="jumpToHref(item.link)">
          </li>
        </ul>
      </div>
      <div class="box-li">
        <ul class="logo-ul">
          <li class="logo-li" v-for="(item,index) in logoArr" :key="index">
            <img class="img" :src="item.img" alt="" @click="jumpToHref(item.link)">
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name       : 'index-logo-list',
  components : {},
  props      : {
    logoArr : {
      type    : Array,
      default : [],
    },
  },
  data(){
    return {
      swiperOptions : {
        speed                          : 800,
        slidesPerView                  : 5, // 设置slider容器能够同时显示的slides数量
        centeredSlides                 : true, // active slide会居中，而不是默认状态下的居左。
        loop                           : true,
        autoplay                       : {
          delay                : 800,
          disableOnInteraction : false,
        },
        preventInteractionOnTransition : false,
      },
    };
  },
  computed   : {},
  created(){},
  mounted(){
    /*this.$nextTick(()=>{
      console.log(this.$refs.logow.offsetWidth);
    })*/
  },
  methods    : {
    jumpToHref(url){
      this.$emit('jumpToHref', url);
    },
  },
};
</script>
<style scoped lang="scss">
.logoBox{
  overflow: hidden;
  .box{
    display: flex;
    width: 200%;
    animation: 30s linear 0s infinite normal none running rotate;
    @keyframes rotate{
      100%{
        transform: translateX(-150%);
      }
    }
    .box-li{
      flex:1;
    }
  }
}
.logo-ul{
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 0 0 100%;
  padding: 0.2rem 0;
  @at-root .logo-li{
    display: flex;
    align-items: center;
    justify-content: center;
    @extend %btn_base;
    margin-right: 26Px;
    .img{
      max-width: 170Px;
    }
  }
}
</style>
